export const base_path = "/";
export const img_path = "/react/template/";

// Base Url Path
export const apibaseurl = "https://engine.ihfc.trainer.mcitiservices.com";

// export const apibaseurl = "https://engine.ihfc.trainer.mcitiservices.com";

// export const candidate_portal = "http://192.168.1.6:8585"
export const candidate_portal = "https://engine.ihfc.candidate.mcitiservices.com"

// export const apibaseurl = "https://ihfc.candidate.physus.org:8989";

// export const apibaseurlsec = "http://192.168.1.1:8989";
// export const apibaseurl = "https://weconnect.bizclockinfotech.com:9090"
export const localHostUrl = "http://localhost:3000/";

export const jwttoken = localStorage.getItem("token");
